import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromCustomConfiguration from './custom-configuration.reducer';

export const selectCustomConfigurationState = createFeatureSelector<fromCustomConfiguration.State>(
  fromCustomConfiguration.customConfigurationFeatureKey
);

export const selectTableColumns = createSelector(
  selectCustomConfigurationState,
  (state) => state.tableColumns);
export const selectHierarchicalTableColumns = createSelector(
  selectCustomConfigurationState,
  (state) => state.hierarchicalTableColumns);
